import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormService } from '@app/shared/services/form/form.service';
import { ProgressbarService } from '@app/shared/services/progressbar/progressbar.service';
import { PageEnum } from '@app/core/enums/page-enum';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-service-systematics-form',
  templateUrl: './service-systematics-form.component.html',
  styleUrls: ['../../../../..//app.component.sass']
})
export class ServiceSystematicsFormComponent implements OnInit {

  serviceSystematicsForm: FormGroup;
  premium: Observable<boolean>;
  @Output() pageChanged: EventEmitter<number> = new EventEmitter<number>();
  @Output() scrollTop = new EventEmitter<boolean>();

  constructor(private formService: FormService, private progressBarService: ProgressbarService) {
  }

  ngOnInit() {
    this.serviceSystematicsForm = this.formService.leistungsSystematikForm;
    this.premium = this.formService.isPremium;
    this.scrollTop.emit(true);
  }

  onSubmit() {
    this.pageChanged.emit(PageEnum.FORM_BAV);
    this.progressBarService.increasePercentage(this.formService.PROCESS_STEP);
  }

  previousPage() {
    this.pageChanged.emit(PageEnum.FORM_SERVICES);
    this.progressBarService.decreasePercentage(this.formService.PROCESS_STEP);
  }
}
